module.exports = __webpack_public_path__ + "static/media/Omega_MessageCenter_iD_R2May082020-08.5449528d.png";